import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Student } from 'core/models/student';
import { UsersService } from './users.service';
import { JobsService } from './jobs.service';

@Injectable()
export class StudentsService extends UsersService {
  constructor(protected injector: Injector, protected jobsService: JobsService) {
    super(injector, jobsService);
  }

  public createStudents(clientId: string, data: any): Promise<any> {
    return super.createUsers(clientId, data);
  }

  public getStudent(id: string): Observable<Student> {
    return this.getUser(id);
  }

  public updateStudent(userId: string, data: any): Promise<any> {
    const url = `${this.baseUrl}/${userId}`;
    return super.putRequest(url, JSON.stringify(data), this.getRequestOptions());
  }

  public updateBulkStudents(data: any): Promise<any> {
    return super.putRequest(`${this.baseUrl}/`, JSON.stringify(data), this.getRequestOptions());
  }
}
